<template>
  <div :class="{
    'cell-wrap': true,
    'cell-first': isOnly || isFirst,
    'cell-last': isOnly || isLast,
  }">
    <div v-if="name" class="cell-name">{{name}}</div>
    <div class="cell-content">
      <slot></slot>
      <div class="with_arrow" v-if="isLink"></div>
    </div>
    <div :class="{'cell-border': isBorder}" v-if="!isOnly && !isLast && isBorder"></div>
  </div>
</template>

<script>
export default {
  props: {
    isOnly: {
      default: false,
      type: Boolean
    },
    isFirst: {
      default: false,
      type: Boolean
    },
    isLast: {
      default: false,
      type: Boolean
    },
    isBorder: {
      default: true,
      type: Boolean
    },
    name: {
      default: '',
      type: String
    },
    isLink: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;
.cell-wrap {
  padding: 0 30/@w2;
  height: 110/@w2;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-items: flex-start;
  justify-content: space-between;
  position: relative;
  background: #fff;
  overflow: hidden;
  flex: 1;
  .cell-border {
    @diff: 60/@w2;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: calc(~"100% - " @diff);
    height: 1px;
    background-color: #DADBE0;
  }
  .cell-name {
    color: #141E33;
    font-size: 30/@w2;
    padding-right: 10 / @w2;
  }
  .cell-content {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    .with_arrow:after {
      top: 0;
    }
  }
}
.cell-first {
  margin-top: 20/@w2;
  border-top-left-radius: 16/@w2;
  border-top-right-radius: 16/@w2;
}
.cell-last {
  border-bottom-left-radius: 16/@w2;
  border-bottom-right-radius: 16/@w2;
  margin-bottom: 20/@w2;
}
</style>
